<template>
  <H5Layout title="角色管理" active="">
    <ZRole></ZRole>
  </H5Layout>
</template>

<script>
import H5Layout from "./H5Layout.vue";
import ZRole from "@/vue_views/ZRole.vue";

export default {
  name: "RoleH5",
  components: {
    H5Layout,
    ZRole
  }
}
</script>

<style>
.h5-layout .el-table__body-wrapper {
  overflow-x: auto;
}
</style>
